<!--
 * @Author: junrui_lv junrui_lv@lebo.cn
 * @Date: 2023-02-08 10:34:06
 * @LastEditors: junrui_lv junrui_lv@lebo.cn
 * @LastEditTime: 2023-02-10 14:05:31
 * @FilePath: /web-SaaS/src/components/dragAdjustWidth/src/main.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="resize" >
    ⋮
  </div>
</template>
<script>
export default {
  name: 'dragAdjustWidth',
  props: {
    wrapperBox: {
      type: String,
      default: 'wrapContent'
    },
    leftBox: {
      type: String,
      default: 'leftBox'
    },
    rightBox: {
      type: String,
      default: 'rightBox'
    }
  },
  mounted() {
    this.dragController()
  },
  methods: {
    dragController() {
      let resize = document.getElementsByClassName('resize')
      let left = document.getElementsByClassName(this.leftBox)
      let right = document.getElementsByClassName(this.rightBox)
      let box = document.getElementsByClassName(this.wrapperBox)
      for(let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function(e) {
          // 颜色改变提醒
          resize[i].style.background = '#818181';
          resize[i].style.cursor = 'col-resize';
          let startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          // 鼠标拖动事件
          document.onmousemove = function(e) {
            var endX = e.clientX;
            let moveLen = resize[i].left + (endX - startX); //. 左边区域的宽度
            let maxT = box[i].clientWidth - resize[i].offsetWidth; // 右边区域的宽度
            if(moveLen < 200) moveLen = 200 // 左边区域的最小宽度为200
            if(moveLen > maxT - 200) moveLen = maxT - 200 // 右边区域的最小宽度为200
            resize[i].style.left = moveLen; // 设置左侧区域的宽度
            for(let j = 0; j < left.length; j++) {
              left[j].style.width = moveLen + 'px';
              right[j].style.width = box[i].clientWidth - moveLen - 25 + 'px'
            }
          }
          // 鼠标松开
          document.onmouseup = function() {
            // 颜色恢复
            resize[i].style.background = "#d6d6d6";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); // 释放鼠标
            return false;
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/*拖拽区div样式*/
.resize {
  cursor: col-resize;
  position: relative;
  top: 250px;
  background-color: #d6d6d6;
  border-radius: 5px;
  margin-top: -10px;
  width: 12px;
  height: 60px;
  line-height: 60px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
  text-align: center;
}
/*拖拽区鼠标悬停样式*/
.resize:hover {
  color: #444444;
}

</style>